const doc = [({"en":({"adminConstantHotelStayType":({"allTypes":"Accommodation and Day Trips", "oneDayTrip":"One day trip only", "stay":"Accommodation only"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;